import React, { useState } from "react";
import { EditorContent, useEditor } from "@tiptap/react";
import StarterKit from "@tiptap/starter-kit";

const RichTextEditor: React.FC = () => {
  const [plainText, setPlainText] = useState<string>("");

  // Initialize the Tiptap editor
  const editor = useEditor({
    extensions: [StarterKit],
    content: "<p>This is a rich text editor! Hello {customerName}</p>",
    onUpdate: ({ editor }) => {
      // Update plain text whenever the content changes
      const textContent = editor.getText();
      setPlainText(textContent);
    },
  });

  // Cleanup the editor instance
  React.useEffect(() => {
    return () => {
      editor?.destroy();
    };
  }, [editor]);

  return (
    <div style={{ display: "flex", gap: "20px" }}>
      {/* Rich Text Editor */}
      <div style={{ flex: 1, border: "1px solid #ccc", padding: "10px" }}>
        <h3>Rich Text Editor</h3>
        {editor && <EditorContent editor={editor} />}
      </div>

      {/* Textarea for Plain Text */}
      <div style={{ flex: 1 }}>
        <h3>Plain Text Output</h3>
        <textarea
          style={{ width: "100%", height: "200px" }}
          value={plainText}
          readOnly
        />
      </div>
    </div>
  );
};

export default RichTextEditor;
